import ErrorPage from '@pages/ErrorPage/ErrorPage';

export default ErrorPage;
